import Vue from 'vue';
// 创建事件总线
export const eventBus = new Vue();

// 事件类型
export enum EventType {
    // 权限更新事件
    PERMISSIONS_UPDATED = 'permissions_updated',
    // 菜单切换事件
    MENU_CHANGED = 'menu_changed',
    // 用户信息更新事件
    USER_INFO_UPDATED = 'user_info_updated',
    // 消息计数更新事件
    MESSAGE_COUNT_UPDATED = 'message_count_updated'
}